(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5079],{

/***/ 28624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Support; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/CartSupport/Support.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Wrapper",
  componentId: "sc-7gaa89-0"
})(["border:1px solid ", ";border-radius:", ";padding:", ";margin-top:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(25), function (props) {
  return props.withoutMargin ? 0 : (0,polished_esm/* rem */.hO)(60);
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Content",
  componentId: "sc-7gaa89-1"
})(["display:flex;"]);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Supportelements__Image",
  componentId: "sc-7gaa89-2"
})(["min-width:", ";height:", ";min-height:", ";height:", ";margin-top:", ";@media (min-width:", "px){min-height:", ";min-width:", ";}"], (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(105), (0,polished_esm/* rem */.hO)(105));
var Details = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Supportelements__Details",
  componentId: "sc-7gaa89-3"
})(["display:flex;flex-direction:column;padding-left:", ";position:relative;width:100%;@media (min-width:", "px){justify-content:center;}"], (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm);
var Question = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Supportelements__Question",
  componentId: "sc-7gaa89-4"
})(["font-size:", ";padding-bottom:", ";display:block;line-height:", ";font-weight:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h5;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(30), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
});
var Description = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Supportelements__Description",
  componentId: "sc-7gaa89-5"
})(["padding-bottom:", ";line-height:", ";color:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(20), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.grey;
});
var Phone = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Supportelements__Phone",
  componentId: "sc-7gaa89-6"
})(["font-weight:", ";", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, function (_ref6) {
  var colors = _ref6.colors,
      theme = _ref6.theme;
  return colors ? "color: ".concat(colors === null || colors === void 0 ? void 0 : colors.colorLink, ";") : "color: ".concat(theme.colors.primary);
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CartSupport/Support.tsx







var SupportTemplate = function SupportTemplate(_ref) {
  var withoutMargin = _ref.withoutMargin,
      withoutBackground = _ref.withoutBackground,
      colors = _ref.colors;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    withoutMargin: withoutMargin,
    withoutBackground: withoutBackground,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Question, {
      children: t('cart.support.question')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: (0,url_utils/* publicAssets */.VK)('/contact_person_shop.png')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Details, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
          children: t('cart.support.description')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Phone, {
          href: "tel:".concat(t('cart.support.phone')),
          colors: colors,
          children: t('cart.support.phone')
        })]
      })]
    })]
  });
};

/* harmony default export */ var Support = (SupportTemplate);

/***/ }),

/***/ 66693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ prihlasenie; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/CartSupport/Support.tsx + 1 modules
var Support = __webpack_require__(28624);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(94951);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Modal/Modal.tsx + 9 modules
var Modal = __webpack_require__(82059);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/store/ui.ts
var ui = __webpack_require__(18770);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Login/Login.elements.tsx





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Loginelements__Wrapper",
  componentId: "sc-koe6j9-0"
})(["display:flex;flex-direction:column;margin-top:", ";@media (min-width:", "px){margin-top:", ";flex-direction:row;}"], (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf));
var Login = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Loginelements__Login",
  componentId: "sc-koe6j9-1"
})(["text-align:center;margin:0 auto;padding:", ";@media (min-width:", "px){width:", ";}@media (min-width:", "px){padding:", " ", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(320), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20));
var Registration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Loginelements__Registration",
  componentId: "sc-koe6j9-2"
})(["background:", ";display:flex;flex-direction:column;align-items:center;padding:", ";border-radius:", ";@media (min-width:", "px){width:50%;padding:", " ", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.darkLight;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(8), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20));
var RegistrationBenefits = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Loginelements__RegistrationBenefits",
  componentId: "sc-koe6j9-3"
})(["display:flex;flex-direction:column;"]);
var RegistrationBenefitsQuestion = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Loginelements__RegistrationBenefitsQuestion",
  componentId: "sc-koe6j9-4"
})(["padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(15));
var RegistrationBenefitsAnswer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Loginelements__RegistrationBenefitsAnswer",
  componentId: "sc-koe6j9-5"
})(["padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(5));
var RegistrationBenefitsAnswerIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Loginelements__RegistrationBenefitsAnswerIcon",
  componentId: "sc-koe6j9-6"
})(["svg{width:", ";height:", ";opacity:0.6;margin-right:", ";}"], (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10));
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Loginelements__Label",
  componentId: "sc-koe6j9-7"
})(["font-weight:", ";font-size:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h6;
});
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Loginelements__Description",
  componentId: "sc-koe6j9-8"
})(["line-height:", ";"], (0,polished_esm/* rem */.hO)(24));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Login/Login.tsx













var LoginTemplate = function LoginTemplate() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Login, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        children: t('shop.login.label')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: t('shop.login.description')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        onClick: function onClick() {
          return dispatch((0,ui/* openModalType */.$X)({
            type: Modal/* ModalTypes.LOGIN */.Q.LOGIN
          }));
        },
        marginTop: 20,
        marginBottom: 40,
        text: t('shop.login.account.login')
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Registration, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        children: t('shop.registration.label')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        onClick: function onClick() {
          return router.push({
            pathname: constants/* ROUTES.REGISTER */.Z6.REGISTER
          });
        },
        marginTop: 30,
        marginBottom: 30,
        text: t('shop.login.account.register')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RegistrationBenefits, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RegistrationBenefitsQuestion, {
          children: t('shop.registration.question')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RegistrationBenefitsAnswer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RegistrationBenefitsAnswerIcon, {
            name: Icon/* Icons.CheckThin */.PJ.CheckThin
          }), t('shop.registration.benefit1')]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RegistrationBenefitsAnswer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RegistrationBenefitsAnswerIcon, {
            name: Icon/* Icons.CheckThin */.PJ.CheckThin
          }), t('shop.registration.benefit2')]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RegistrationBenefitsAnswer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RegistrationBenefitsAnswerIcon, {
            name: Icon/* Icons.CheckThin */.PJ.CheckThin
          }), t('shop.registration.benefit3')]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RegistrationBenefitsAnswer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RegistrationBenefitsAnswerIcon, {
            name: Icon/* Icons.CheckThin */.PJ.CheckThin
          }), t('shop.registration.benefit4')]
        })]
      })]
    })]
  });
};

/* harmony default export */ var Login_Login = (LoginTemplate);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
;// CONCATENATED MODULE: ./src/pages/prihlasenie.tsx

















var prihlasenie_Login = function Login() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  var isLoggedInState = (0,es/* useSelector */.v9)(function (state) {
    return state.ui.isLoggedIn;
  });

  var _useState = (0,react.useState)(false),
      isLoggedIn = _useState[0],
      setIsLoggedIn = _useState[1];

  (0,react.useEffect)(function () {
    console.log('TOKEN', isLoggedIn, isLoggedInState, js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY */.Wx));

    if (!isLoggedIn && isLoggedInState) {
      setIsLoggedIn(isLoggedInState);
      router.replace({
        pathname: constants/* ROUTES.SHOP_PARTICIPANTS */.Z6.SHOP_PARTICIPANTS
      });
    }
  }, [isLoggedInState]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.login.title'),
      description: t('seo.login.description'),
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK,
      openGraph: {
        images: [{
          url: "https://profivzdelavanie.sk".concat((0,url_utils/* publicAssets */.VK)('/og-konferencia.png'))
        }]
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      withPadding: true,
      sidePadding: 20,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Login_Login, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Support/* default */.Z, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var prihlasenie = (prihlasenie_Login);

/***/ }),

/***/ 52781:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prihlasenie",
      function () {
        return __webpack_require__(66693);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,4623,9774,2888,179], function() { return __webpack_exec__(52781); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);